import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { isBeneficiary } from 'utils';
import { DownloadedItems } from './components/index';
import { flattenDocs } from './utils';
import DocsInvestor from './components/docsInvestor';
import { isEmpty } from 'lodash';
import { Empty} from 'antd';
import { content, contentView} from './components/docsInvestor/content';


const Documents = () => {
  const docs = useSelector(state => state.forms.documents);
  const viewMode = useSelector(state => state.forms.carrier.viewMode);
  const flatDocs = flattenDocs(docs.contentItems);
  const user = useSelector(state => state.user);

  const documents = useSelector(state => state.forms.documents);
  const ownerStatus = useSelector(state => state.forms.carrier.ownerStatus);
  const residence = useSelector(state => state.forms.carrier.residence);  
  const ameaMember = useSelector(state => state.forms.carrier.ameaMember); 

  return !viewMode && isBeneficiary(user?.groups) ? (
    <div>
      <div className="mt-6"/>
      <DocsInvestor group={'documents'} />
      <div className="mt-2 " />
    </div>
  ) 
    :
    (
    <div style={{minHeight:"500px"}}  >
      <div className="mt-6"/>
      {/* <DownloadedItems content={content_onlyNP} docs={flatDocs} />
      <DownloadedItems content={content_existCon} docs={flatDocs} /> */}
      {
        isEmpty(documents) ?
        <div style={{position:"absolute", top:"10%", left:"50%"}}>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<>No data</>} />
        </div>
        :
        <DownloadedItems content={contentView(ownerStatus, ameaMember, residence)} docs={flatDocs} />
      }
    </div>
  );
};

Documents.propTypes = {
  group: PropTypes.string.isRequired,
};

export default Documents;
